import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@angular/material';
import { DataTableModule, CalendarModule } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';
import { CommonPipesModule } from 'app/shared/pipes/common-pipes.module';

import { AlertsService } from 'app/alerts/alerts.service';
import { AlertsInboxComponent } from 'app/alerts/alerts-inbox.component';
import { AlertDetailDrawerComponent } from 'app/alerts/alert-detail-drawer.component';

@NgModule({
    declarations: [
        AlertsInboxComponent,
        AlertDetailDrawerComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MaterialModule.forRoot(),
        DataTableModule,
        CalendarModule,
        SharedModule,
        CommonPipesModule
    ],
    providers: [
        AlertsService
    ],
    entryComponents: [
        AlertDetailDrawerComponent
    ],
    exports: [
        AlertsInboxComponent,
        AlertDetailDrawerComponent
    ]
})
export class AlertsModule { }



// WEBPACK FOOTER //
// ./src/app/alerts/alerts.module.ts